import RichText from './rich-text';
import './styles/index.scss';
export { RichText as default };
